import { jsx } from "react/jsx-runtime";
import { useCallback } from "react";
import { ItemRenderer } from "./components/ItemRenderer/index.js";
function useRenderOption(props) {
  const {
    multiSelectState,
    multiSelectState: { props: componentProps }
  } = props;
  const normalRenderOption = useCallback(
    (props2, option, autoCompleteState) => {
      if (componentProps.optionMode !== "normal") return null;
      const getId = componentProps.getId;
      const getOptionLabel = componentProps.getLabel;
      const ItemEndAdornment = componentProps.ItemEndAdornment;
      const uid = getId?.(option) ?? getOptionLabel(option);
      return /* @__PURE__ */ jsx(
        ItemRenderer,
        {
          option,
          itemProps: props2,
          getOptionLabel,
          ItemEndAdornment,
          multiSelectState,
          autoCompleteState
        },
        uid
      );
    },
    [componentProps, multiSelectState]
  );
  const customRenderOption = useCallback(
    (props2, option, autoCompleteState) => {
      if (componentProps.optionMode !== "custom") return null;
      return componentProps.renderOption(props2, option, autoCompleteState, multiSelectState);
    },
    [componentProps, multiSelectState]
  );
  switch (componentProps.optionMode) {
    case "custom":
      return customRenderOption;
    case "normal":
      return normalRenderOption;
  }
}
export {
  useRenderOption
};
//# sourceMappingURL=useRenderOption.js.map
